import { Injectable, EventEmitter } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs/Rx';
import { Response } from '@angular/http';
// Interfaces
import {
	IService,
	IApplicationModel, IContact, IStepModel, IQuestion, IQuestionModel, IQuestionsModel, IAWSS3Model, IAWSS3
} from '../../interfaces';
// classes
import { ApplicationCreateForm, ApplicationForm, ApplicationModel, ApplicationStatus } from '../../classes';
// Enums
import { ApplicationStatusEnum } from '../../enums';
// Services

import { LogService} from '../../services/log/log.service';
import { ServerService} from '../../services/server/server.service';
import { HelperService} from '../../services/helper/helper.service';
import { UserService} from '../../services/user/user.service';
import { StorageService} from '../../services/storage/storage.service';

@Injectable()
export class QuestionService implements IService {
	// implements local variables
	_questions = new BehaviorSubject<IQuestionsModel>(undefined);
	_data: {
		Questions: IQuestionsModel
	};

	// implements IService
	name = 'QuestionService';
	test(name, value) {
		console.log('testing', name, value);
	}

	constructor(
		private _logSrv: LogService,
		private _userSrv: UserService,
		private _serverSrv: ServerService,
		private _helperSrv: HelperService,
		private _storageSrv: StorageService
	) { }


	get QUESTIONS() {
		return this._questions;
	}

	set Questions(value: IQuestionsModel) {

		this._questions.next(value);
	}

	Get(stepid: string): Promise<IQuestionsModel> {
		const key = this._storageSrv.GetKey(this._storageSrv.KEY_STEP);
		const endPoint = `${this._helperSrv.ApiLocation}question/stepid/${stepid}/key/${key}`;
		this._logSrv.Debug(this.name, ['Post', { endPoint: endPoint, Step: stepid }]);
		return this._serverSrv.GetWithAuth(
			this._userSrv.Data.contact.AcepId,
			endPoint)
			.map(response => {
				if (response.status === 200) {
					const body = response.json();
					const data = <IQuestionsModel>body.Data;
					this._logSrv.Debug(this.name, ['Get', data]);
					return data;
				} else {
					throw new Error(response.statusText);
				}
			})
			.toPromise();
	}


	GetByQuestionkey(questionkey: string, applicationid: string): Promise<IQuestionModel> {
		
		const endPoint = `${this._helperSrv.ApiLocation}question/questionkey/${questionkey}/applicationid/${applicationid}`;
		
		return this._serverSrv.GetWithAuth(
			this._userSrv.Data.contact.AcepId,
			endPoint)
			.map(response => {
				if (response.status === 200) {
					const body = response.json();
					const data = <IQuestionModel>body.Data;
					this._logSrv.Debug(this.name, ['Get', data]);
					return data;
				} else {
					throw new Error(response.statusText);
				}
			})
			.toPromise();
	}

	/**
	 * Adds a question
	 * @param Question question object
	 * @param stepid guid step id
	 */
	Post(Question: IQuestion): Promise<IQuestionModel> {
		const url = `${this._helperSrv.ApiLocation}question/add/stepid/${Question.StepId}`;
		this._logSrv.Debug(this.name, ['Post save', { url: url, Question: Question }]);
		return this._serverSrv.PostWithAuth(
			this._userSrv.Data.contact.AcepId,
			url,
			Question)
			.map(response => {
				if (response.status === 200) {
					const body = response.json();
					const data = <IQuestionModel>body.Data;
					return data;
				} else {
					throw new Error(response.statusText);
				}
			})
			.toPromise();
	}

	/**
	 * Updates a question
	 * @param url endpoint
	 * @param Question question object
	 */
	Put(url: string, Question: IQuestion): Promise<IQuestionModel> {
		this._logSrv.Debug(this.name, ['Post', { url: url, Question: Question }]);
		return this._serverSrv.PutWithAuthWithURL(
			this._userSrv.Data.contact.AcepId,
			url,
			Question)
			.map(response => {
				if (response.status === 200) {
					const body = response.json();
					const data = <IQuestionModel>body.Data;
					return data;
				} else {
					throw new Error(response.statusText);
				}
			})
			.toPromise();
	}

	/**
	 * adds questions and completes step
	 * @param url endpoint
	 * @param Questions question array
	 */
	PostQuestions(url: string, Questions: IQuestion[]): Promise<IQuestionsModel> {
		this._logSrv.Debug(this.name, ['Post', { url: url, Questions: Questions }]);
		return this._serverSrv.PostWithAuthWithURL(
			this._userSrv.Data.contact.AcepId,
			url,
			Questions)
			.map(response => {
				if (response.status === 200) {
					const body = response.json();
					const data = <IQuestionsModel>body.Data;
					return data;
				} else {
					throw new Error(response.statusText);
				}
			})
			.toPromise();
	}

	/**
	 * updates questions and completes step
	 * @param url endpoint
	 * @param Questions question array
	 */
	PutQuestions(url: string, Questions: IQuestion[]): Promise<IQuestionsModel> {
		this._logSrv.Debug(this.name, ['Put', { url: url, Questions: Questions }]);
		return this._serverSrv.PutWithAuthWithURL(
			this._userSrv.Data.contact.AcepId,
			url,
			Questions)
			.map(response => {
				if (response.status === 200) {
					const body = response.json();
					const data = <IQuestionsModel>body.Data;
					return data;
				} else {
					throw new Error(response.statusText);
				}
			})
			.toPromise();
	}


	Delete(url: string, id: string): Promise<boolean> {
		// const endPoint = `${this._helperSrv.ApiLocation}question`;
		this._logSrv.Debug(this.name, ['Delete question', { endpoint: url, Questions: id }]);
		return this._serverSrv.DeleteWithAuthWithURL(
			this._userSrv.Data.contact.AcepId,
			url)
			.map(response => {
				if (response.status === 200) {
					this._logSrv.Debug(this.name, ['Delete question', response]);
					return true;
				} else {
					throw new Error(response.statusText);
				}
			})
			.toPromise();
	}

	GetFriendlyName(from: string)
	{
		let to: string = '';
		if(from.indexOf('guideline') > -1)
		{
           to = from.replace('guideline','Criteria_Access');
		}

		else if(from.indexOf('delirium') > -1)
		{
           to = from.replace('delirium','Delirium_Screen');
		}

		else if(from.indexOf('dementia') > -1)
		{
           to = from.replace('dementia','Dementia_Screen');
		}

		else if(from.indexOf('function') > -1)
		{
           to = from.replace('function','Functional_Decline');
		}

		else if(from.indexOf('protocol') > -1)
		{
           to = from.replace('protocol','Fall_Assess');
		}

		else if(from.indexOf('identification') > -1)
		{
           to = from.replace('identification','ID_Elder_Abuse');
		}

		else if(from.indexOf('medication') > -1)
		{
           to = from.replace('medication','Med_Reconcile');
		}

		else if(from.indexOf('inappropriatemedication') > -1)
		{
           to = from.replace('inappropriatemedication','Inappropriate_Meds');
		}

		else if(from.indexOf('pain') > -1)
		{
           to = from.replace('pain','Pain_Protocol');
		}

		else if(from.indexOf('palliative') > -1)
		{
           to = from.replace('palliative','Access_Palliative_Care');
		}

		else if(from.indexOf('Geriatric') > -1)
		{
           to = from.replace('Geriatric','Psych_Consult');
		}

		else if(from.indexOf('implementationGeriatric') > -1)
		{
           to = from.replace('implementationGeriatric','3_Order_Sets');
		}

		else if(from.indexOf('urinarycatheter') > -1)
		{
           to = from.replace('urinarycatheter','Urinary_Cath');
		}

		else if(from.indexOf('NPOdesignation') > -1)
		{
           to = from.replace('NPOdesignation','Minimize_NPO');
		}

		else if(from.indexOf('promotemobility') > -1)
		{
           to = from.replace('promotemobility','Promote_Mobility');
		}

		else if(from.indexOf('volunteerengagement') > -1)
		{
           to = from.replace('volunteerengagement','Volunteer_Engage');
		}

		else if(from.indexOf('dischargeprotocol') > -1)
		{
           to = from.replace('dischargeprotocol','Discharge_Home');
		}

		else if(from.indexOf('PCPnotification') > -1)
		{
           to = from.replace('PCPnotification','PCP_Notification');
		}

		else if(from.indexOf('residentialcare') > -1)
		{
           to = from.replace('residentialcare','TOC_Residential');
		}

		else if(from.indexOf('physicalrestraints') > -1)
		{
           to = from.replace('physicalrestraints','Restraints');
		}

		else if(from.indexOf('geriatricspecific') > -1)
		{
           to = from.replace('geriatricspecific','Followup_Clinics');
		}

		else if(from.indexOf('post­discharge') > -1)
		{
           to = from.replace('post­discharge','Post_Discharge');
		}

		else if(from.indexOf('transportation') > -1)
		{
           to = from.replace('transportation','Transport_Residence');
		}

		else if(from.indexOf('long­termrehabilitation') > -1)
		{
           to = from.replace('long­termrehabilitation','Access_Rehab');
		}

		else if(from.indexOf('outreachprogram') > -1)
		{
           to = from.replace('outreachprogram','Outreach');
		}


		else if(from.indexOf('activerelationship') > -1)
		{
           to = from.replace('activerelationship','Paramedicine');
		}

		to = to.replace('level1_Policies','Level_1_Policy').replace('level1_Quality','Level_1_Quality');

		to = to.replace('level2_Policies','Level_2_Policy').replace('level2_Quality','Level_2_Quality');


		if (to == '')
		{
			to = from;
		}
		return to;
		
	}
}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/services/question/question.service.ts